const state = () => ({
  // 公告
  newNotice: '',
  /** 更新时间 */
  endTime: '',
  // 聊天消息
  chatMessageList: []
});
const actions = {

}
const mutations = {
  //更新公告
  setNotice(state, value) {
    state.newNotice = value;
  },
  setEndTime(state, value) {
    state.endTime = value;
  },
  setChatMessageList(state, value) {
    state.chatMessageList = value;
  }

};

export default {
  namespaced: true,
  state,
  mutations,
};
